import { put, takeLatest, call } from 'redux-saga/effects'
import { ssoActions } from './SSOActions'
import { ssoReducers } from './SSOSlice'
import { getSsoCompanies } from './services'

function* getSsoCompaniesSaga() {
  yield put(ssoReducers.setLoading(true))
  yield put(ssoReducers.setError(null))
  try {
    const response = yield call(getSsoCompanies)
    if (response.status === 200) {
      yield put(ssoReducers.getSsoCompaniesSuccess(response.data))
    } else {
      yield put(
        ssoReducers.getSsoCompaniesFailed('Failed to fetch SSO companies')
      )
    }
  } catch (error: any) {
    yield put(
      ssoReducers.getSsoCompaniesFailed(
        error?.response?.data?.message || 'Failed to fetch SSO companies'
      )
    )
  }
}

export function* ssoSaga() {
  yield takeLatest(ssoActions.getSsoCompanies.type, getSsoCompaniesSaga)
}

export default ssoSaga
